enum OverallMapDropdownFilter {
  Cities = 'dd_cities',
  Countries = 'dd_countries',
  CreativeFormats = 'dd_creative_formats',
  CreativeOrientations = 'dd_creative_orientations',
  IabCategories = 'dd_iab_categories',
  Languages = 'dd_languages',
  Markets = 'dd_markets',
  MediaTypes = 'dd_media_types',
  Networks = 'dd_networks',
  Proximity = 'dd_proximity',
  Regions = 'dd_regions',
  Sites = 'dd_sites',
  Tags = 'dd_tags',
  UnitPacks = 'dd_unitpacks',
  Units = 'dd_units',
}

export default OverallMapDropdownFilter;
